<script>
	import {
		redirectLucid,
		redirectProlific,
		redirectMTurk,
	} from "../placeholderText.js";

	export let conditions;
	let platformParams = {
		platform: "",
		"redirect-url": "",
		"completion-code": "",
	};
	let redirectExample;

	const updateRedirectExample = () => {
		if (platformParams.platform == "lucid") {
			redirectExample = redirectLucid;
		} else if (platformParams.platform == "prolific") {
			redirectExample = redirectProlific;
		} else if (platformParams.platform == "mturk") {
			redirectExample = redirectMTurk;
		} else if (platformParams.platform == "custom") {
			redirectExample = "https://www.google.com";
		} else {
			redirectExample = undefined;
		}
	};
	$: if (platformParams) {
		updateRedirectExample();
	}

	const getStorage = () => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.platformParams) {
				platformParams = params["platformParams"];
			}
		} else {
			params = {};
		}
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["platformParams"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(platformParams);

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: parameters["platform"], // duplicate for all conditions
			});
			formatted.push({
				condition: i + 1,
				param: "completion-code",
				value: parameters["completion-code"], // duplicate for all conditions
			});
			formatted.push({
				condition: i + 1,
				param: "redirect-url",
				value: parameters["redirect-url"], // duplicate for all conditions
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, platformParams, "platform");
</script>

<section>
	<hr />
	<h3>Recruitment platform</h3>
	<div>
		<p>
			If <strong>None</strong>, redirects to home page (or top of page)
			after submission.
		</p>
		<label for={"platform"} />
		<select name={"platform"} bind:value={platformParams["platform"]}>
			<option value="">None</option>
			<option value="mturk">MTurk</option>
			<option value="prolific">Prolific</option>
			<option value="lucid">Lucid</option>
			<option value="custom">Custom</option>
		</select>
	</div>

	{#if platformParams.platform !== undefined && platformParams.platform !== null && platformParams.platform !== ""}
		{#if platformParams.platform !== "mturk"}
			<label for="redirect-url"><h4>Redirection/completion URL</h4></label
			>
			<p>
				Follow the instructions (for Qualtrics) on your recruitment
				platform and paste redirection/completion URL below.
			</p>

			<p>
				Example: <code>{redirectExample}</code>
			</p>

			<input
				name="redirect-url"
				type="text"
				style="width:89%"
				bind:value={platformParams["redirect-url"]}
			/>
		{/if}

		{#if platformParams["platform"] === "mturk"}
			<h4>Completion code</h4>
			<div class="field-container">
				<label for="completion-code" />
				<p>Completion code (recommended for MTurk)</p>
				<input
					name="completion-code"
					type="text"
					bind:value={platformParams["completion-code"]}
				/>
			</div>
		{/if}
	{/if}
</section>

<style>
	label {
		margin-bottom: 8px;
	}
</style>
